import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import FAQ from "./components/FAQ";
import Tarifs from "./components/Tarifs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const Landing = () => (
  <div className="App bg-[#FAF6F1] text-zinc-900">
    <Header />
    <main>
      <Hero />
      <About />
      <Services />
      <Tarifs />
      <FAQ />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
